import { render } from "./TransferIcon.vue?vue&type=template&id=1bd5043e&scoped=true"
const script = {}

import "./TransferIcon.vue?vue&type=style&index=0&id=1bd5043e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd5043e"]])

export default __exports__